import {
  useTwoStepAuthCode,
  CodeModalResult,
} from "@/features/two-step-authentication/hooks/use-two-step-authentication-code";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
//import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import React from "react";
import { useTwoStepAuthCodeStates } from "@/features/two-step-authentication/hooks/use-two-step-authentication-code-states";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { SegmentedForm } from "@/shared/components/text-box/segmented-form";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { Link } from "react-router-dom";

interface CodeProps {
  onCloseModal: () => void;
  onCompleteModal: (result: CodeModalResult) => void;
}

// 2段階認証コード入力モーダル
export const TwoStepAuthCodeModal = ({ onCloseModal, onCompleteModal }: CodeProps) => {
  const {
//    openNotLoginModal,
    setOpenNotLoginModal,
  } = useModalContext();
  const {
    setTwoStepAuthCode,
  } = useLoginContext();
  const {
    verifyCode,
  } = useTwoStepAuthCode({ onCompleteModal });
  const {
    isActiveCodeVerifyButton,
    setIsActiveCodeVerifyButton,
  } = useTwoStepAuthCodeStates();

  return (
    <BasePageModal
      title="2段階認証の設定"
      handleClose={onCloseModal}
      className="md-login-code"
      disableOverlayClose={true}
      bottomChildren={
        <>
          <BaseRoundButton
            id="btnSubmit"
            buttonText="認証コードを送信"
            onClick={verifyCode}
            isActive={isActiveCodeVerifyButton}
          />
        </>
      }
    >
      <h2>
        認証コードを入力してください
      </h2>
      <dl>
        <dt>認証コード</dt>
        <dd className="input_code">
          <SegmentedForm
            onChange={(value, isComplete) => {
              setTwoStepAuthCode(value);
              setIsActiveCodeVerifyButton(isComplete)
            }}
            id={"code"}
            length={6}
          />
        </dd>
      </dl>
      <div className="message">
        <p>受信したメールに記載されている認証コードを入力してください。</p>
        <p>登録したメールアドレスで認証コードが受け取れなくなった場合は、解除コードで2段階認証を無効化できます。</p>
        <p>
          <Link to="#" onClick={() => setOpenNotLoginModal("TwoStepAuthReleaseCode")}>→ 2段階認証を解除コードで無効化する</Link>
        </p>
      </div>
    </BasePageModal>
  );
};
